import React, { useState, useEffect, useContext, useRef } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { Videoplayer } from "@openabos/react-circular-player";
import { green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  CircularProgress,
  ClickAwayListener,
  Divider,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
  useMediaQuery
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CameraAltOutlinedIcon from "@material-ui/icons/CameraAltOutlined";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import FormatListBulletedOutlined from "@material-ui/icons/FormatListBulletedOutlined";
import GetApp from "@material-ui/icons/GetApp";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import LocationOnOutlined from "@material-ui/icons/LocationOnOutlined";
import MediaNotSupportedModal from "../MediaNotSupportedModal";
import MicIcon from "@material-ui/icons/Mic";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import MoodIcon from "@material-ui/icons/Mood";
import MoreVert from "@material-ui/icons/MoreVert";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import PollOutlinedIcon from "@material-ui/icons/PollOutlined";
import SendIcon from "@material-ui/icons/Send";
import WallpaperOutlinedIcon from "@material-ui/icons/WallpaperOutlined";
import clsx from "clsx";
import data from "@emoji-mart/data";
import MicRecorder from "mic-recorder-to-mp3";
import Picker from "@emoji-mart/react";
import "alertifyjs/build/css/alertify.css";
import "@openabos/react-circular-player/dist/cjs/index.css";

import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import api from "../../services/api";
import Audio from "../Audio";
import CameraModal from "../CameraModal";
import checkForShouldSendSignature from "../../utils/checkForShouldSendSignature";
import EventPreviewQuotedMessage from "../EventPreviewQuotedMessage";
import ForwardMessageContactModal from "../ForwardMessageContactModal";
import GroupMembersMentionList from "../GroupMembersMentionList";
import InternalMessageIconContainer from "../InternalMessageIconContainer";
import LocationModal from "../LocationModal";
import LocationPreview from "../LocationPreview";
import MessageEditModal from "../MessageEditModal";
import MessageImage from "../MessageImage";
import MessageUtils from "../../utils/classes/MessageUtils";
import MultiVcardPreview from "../MultiVcardPreview";
import PixMessage from "../PixMessage";
import PixModal from "../PixModal";
import PollModal from "../PollModal";
import PollPreviewQuotedMessage from "../PollPreviewQuotedMessage";
import QuickAnswersList from "../QuickAnswersList";
import RecordingTimer from "./RecordingTimer";
import saveFile from "../../utils/saveFile";
import ShareContactsModal from "../ShareContactsModal";
import StickersModal from "../StickersModal";
import TemplateSendingModal from "../TemplateSendingModal";
import toastError from "../../errors/toastError";
import VcardPreview from "../VcardPreview";
import ViewOnceMessageWeb from "../ViewOnceMessageWeb";
import ViewOnceMessage from "../ViewOnceMessage";
import "../../styles/react-circular-player-new-styles.css";

import DefaultValuesUtils from "../../utils/classes/DefaultValuesUtils";
import JidUtils from "../../utils/classes/JidUtils";
import TemplateMessageUtils from "../../utils/classes/TemplateMessageUtils";

import { useGlobalRegisters } from "../../context/GlobalRegisters/GlobalRegistersContext";

const Mp3Recorder = new MicRecorder({
  bitRate: 128,
  startRecordingAt: 300,
});

const useStyles = makeStyles((theme) => ({
  mediaNameSpan: { inlineSize: "80%", overflowWrap: "break-word", },

  messageMediaVideo: { width: "200px", height: "200px", },

  mainWrapper: {
    borderRadius: "20px",
    background: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: { position: "fixed", bottom: 0, width: "100%", },
  },

  newMessageBox: {
    borderRadius:"20px",
    background: theme.palette.background.default,
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: theme.palette.background.paper,
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
  },

  messageInputWrapperColumn: {
    display: 'flex'
    , flexDirection: 'column'
    , gap: '0px'
    , alignItems: 'center'
    , justifyContent: 'center'
  }

  , messageInput: { borderRadius:"20px", paddingLeft: 10, flex: 1, border: "none", },

  disabledMessageInput: { color: "#888", cursor: "not-allowed", },

  sendMessageIcons: { borderRadius:"20px", color: "grey", },

  uploadInput: { borderRadius:"20px", display: "none", },

  viewMediaInputWrapper: {
    borderRadius:"20px",
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  emojiBox: {
    borderRadius:"20px",
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
    zIndex: 99999,
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: { color: green[500], opacity: "70%", },

  recorderWrapper: { display: "flex", alignItems: "center", alignContent: "middle", },

  cancelAudioIcon: { color: "red", },

  sendAudioIcon: { color: "green", },

  replyingMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyingMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyingMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyingContactMsgSideColor: { flex: "none", width: "4px", backgroundColor: "#35cd96", },

  replyingSelfMsgSideColor: { flex: "none", width: "4px", backgroundColor: "#6bcbef", },

  messageContactName: { display: "flex", color: "#6bcbef", fontWeight: 500, },

  moreVert: { color: "grey", },

  stickerMessage: {
    maxHeight: 225,
    maxWidth: 225,
    borderRadius: 5,
    [theme.breakpoints.down("sm")]: { maxHeight: 150, maxWidth: 150, },
  },

  floatingButton: {
		transition: "all 0.3s ease",
		"&:hover": { transform: "translateY(-5px)" },
	},

  menuList: {
    display: "flex",
    flexDirection: "row",
    width: "250px",
    maxWidth: "250px",
    flexWrap: "wrap",
    borderRadius: "20px",
  },

  takePhotoIcon: { color: "#9c27b0" },
  stickersIcon: { color: "#2196f3" },
  createStickersIcon: { color: "#e91e63" },
  contactsIcon: { color: "#ff5722" },
  pollIcon: { color: "#03a9f4" },
  locationIcon: { color: "#ffc107" },
  attachFileIcon: { color: "#009688" },
  pixIcon: { color: "#4caf50" },
}));

const MessageInput = ({ ticket, ticketStatus, isForwarding, updateIsForwarding, selectedForwardMessages,
  updateSelectedForwardMessages, ticketType, lastMessage, fileContextModalOpen, handleOpenFileContextModal,
  imageToStickerContextModalOpen, handleOpenImageToStickerContextModal, isContactModalOpen, isContactBlocked,
  isContactInactive, setBotAnswerDelay, ticketReadOnly, whatsappId
}) => {  
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { setReplyingMessage, replyingMessage } = useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);
  const { ticketId } = useParams();

  const [cameraModalOpen, setCameraModalOpen] = useState(false);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [pixModalOpen, setPixModalOpen] = useState(false);
  const [pollModalOpen, setPollModalOpen] = useState(false);
  const [progress, setProgress] = useState(0);

  const [inputTextBlurInteraction, setInputTextBlurInteraction] = useState(true);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [signMessageSetting, setSignMessageSetting] = useState();
  const [enterIsSendMobileSetting, setEnterIsSendMobileSetting] = useState("disabled");
  const [shareContactModalOpen, setShareContactModalOpen] = useState(false);
  const [forwardMessageContactModalOpen, setForwardMessageContactModalOpen] = useState(false);
  const [stickersModalOpen, setStickersModalOpen] = useState(false);
  const [templateSendingModalOpen, setTemplateSendingModalOpen] = useState(false);
  
  const [isSendingGif, setIsSendingGif] = useState(false);
  const [isSendingSticker, setIsSendingSticker] = useState(false);
  const [isSendingAudio, setIsSendingAudio] = useState(false);

  const inputContainer = useRef();
  const inputRef = useRef();

  const [messageEditModalOpen, setMessageEditModalOpen] = useState(false);

  const [lastMessageModal, setLastMessageModal] = useState(null);

  // ***---- Internal Message Controller -----***
  const [isInternalMessage, setIsInternalMessage] = useState(false);

  // ***---- Text Message Miscellaneous ----***
  const [groupMembers, setGroupMembers] = useState([]);
  const [typeAt, setTypeAt] = useState(false);
  const [mentionsArray, setMentionsArray] = useState([]);
  const [groupTicketId, setGroupTicketId] = useState(-1);
  const [typeBar, setTypeBar] = useState(false);
  const [groupMessageLock, setGroupMessageLock] = useState(false);

  const [isMediaNoSupportedModalOpen, setIsMediaNoSupportedModalOpen] = useState(false);
  const [mediasNotSupported, setMediasNotSupported] = useState([]);

  const shouldDisableButton = ticketReadOnly || ticketStatus === "closed" || (ticketStatus === "pending" && user.profile !== "admin");

  const { getSetting, allQuickAnswers, isLoading } = useGlobalRegisters();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    if (isLoading) return;

    setSignMessageSetting(getSetting("sendSignatureOnMessages"));
    setEnterIsSendMobileSetting(getSetting("enterIsSendMobile"));
  }, [getSetting, isLoading]);

  useEffect(() => {
    if (lastMessage && lastMessage.fromMe && lastMessage.mediaType && !messageEditModalOpen) {
      setLastMessageModal(lastMessage);
    }
  }, [lastMessage, messageEditModalOpen]);

  useEffect(() => {
    if (isSmallScreen) inputRef.current.blur();
    else inputRef.current.focus();
  }, [replyingMessage, isSmallScreen]);

  useEffect(() => {
    if (isSmallScreen) inputRef.current.blur();
    else inputRef.current.focus();

    return () => {
      setShowEmoji(false);
      setIsSendingGif(false);
      setIsSendingSticker(false);
      setIsSendingAudio(false);
      setReplyingMessage(null);
    };
  }, [ticketId, setReplyingMessage, isSmallScreen]);

  useEffect(() => {
    if (!isSendingGif && !isSendingSticker) {
      setProgress(0);
    }
    else {
      const timer = setInterval(() => setProgress(prevProgress => (prevProgress >= 100 ? 0 : prevProgress + 10)), 800);
      return () => clearInterval(timer);
    }
  }, [isSendingGif, isSendingSticker]);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleOpenMessageEditModal = () => { setMessageEditModalOpen(true); };
  const handleCloseMessageEditModal = () => { setMessageEditModalOpen(false); };
  
  const handleOpenCameraModal = () => { setCameraModalOpen(true); };
  const handleCloseCameraModal = () => { setCameraModalOpen(false); };

  const handleOpenLocationModal = () => { setLocationModalOpen(true); };
  const handleCloseLocationModal = () => { setLocationModalOpen(false); };

  const handleOpenPixModal = () => { setPixModalOpen(true); };
  const handleClosePixModal = () => { setPixModalOpen(false); };

  const handleOpenPollModal = () => { setPollModalOpen(true); };
  const handleClosePollModal = () => { setPollModalOpen(false); };

  const handleOpenTemplateSendingModal = () => { setTemplateSendingModalOpen(true); };
  const handleCloseTemplateSendingModal = () => { setTemplateSendingModalOpen(false); };
  
  const handleDeviceHasCameras = () => { handleOpenCameraModal(); };

  const handleOpenMedialNotSupportedModal = (medias) => {
    setIsMediaNoSupportedModalOpen(true);
    setMediasNotSupported(medias);
  };

  const handleCloseMedialNotSupportedModal = () => {
    setMediasNotSupported([]);
    setIsMediaNoSupportedModalOpen(false);
  };

  const checkMessageMedia = (message) => {
    if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.viewOnce) {
      return (<ViewOnceMessageWeb message={message} />)
    }

    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.location && message.body.split("|").length >= 2) {
      const { imageLocation, linkLocation, descriptionLocation } = MessageUtils.extractLocationInfo(message);
      return <LocationPreview image={imageLocation} link={linkLocation} description={descriptionLocation} />
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.button) { 
      const { buttonTitle, buttonFooter, buttonBody, buttonOptionsArray } = MessageUtils.extractButtonInfo(message);

      return(
        <>
          <b>{buttonTitle}</b>
          <p>{buttonBody}</p>
          <i className={classes.buttonListFooter}>{buttonFooter}</i>
          <hr />
          <center>
            {buttonOptionsArray.map((option, i) => (
              <Button
                color="inherit"
                variant="outlined"
                target="_blank"
                disabled
              >
                {option}
              </Button>
            ))}
          </center>
        </>
      );

    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.list) { 
      const { listTitle, listBody, listOption, listFooter, listOptionsArray } = MessageUtils.extractListInfo(message);
      return (
        <>
          <b>{listTitle}</b>
          <p>{listBody}</p>
          <i className={classes.buttonListFooter}>{listFooter}</i>
          <center>
            <Button
              startIcon={<FormatListBulletedOutlined />}
              color="inherit"
              variant="outlined"
              target="_blank"
              href={message.mediaUrl}
              disabled
            >
              {listOption}
            </Button>
          </center>
          
          <hr />

          <center>
            {listOptionsArray.map((option, i) => (
              <Button
                color="inherit"
                variant="outlined"
                target="_blank"
                href={message.mediaUrl}
                disabled
              >
                {option.split("%%")[0]}
              </Button>
            ))}
          </center>
        </>
      );
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.vcard) {
      const { contact, number } = MessageUtils.extractVcardInfo(message);
      return <VcardPreview contact={contact} number={number} enableHandleNewChat={false} />
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.multiVcard) {
      const { contactsList } = MessageUtils.extractMultivcardInfo(message);
      return <MultiVcardPreview contacts={contactsList} enableStartChat={false} />;
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.image && !message.isViewOnce) {
      return <MessageImage message={message} ticketId={ticketId} replyMessage={true} />
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.image && message.isViewOnce) {
      return <ViewOnceMessage message={message} isPhoto={true} />
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.sticker) {
      return <img className={classes.stickerMessage} src={message.mediaUrl} alt={message.body} />
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.audio) {
      return <Audio url={message.mediaUrl} isVoice={message.isVoice} isFromMe={message.fromMe} />
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.video && !message.isViewOnce) {
      return (
        <video
          className={classes.messageMediaVideo}
          src={message.mediaUrl}
          controls={!message.isGif}
          autoPlay={message.isGif}
          muted={message.isGif}
          loop={message.isGif}
        />
      );
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.video && message.isViewOnce) {
      return <ViewOnceMessage message={message} isPhoto={false} />
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.ptv) {
      return (
        <Videoplayer size={200} src={message.mediaUrl} boundaryColor={"#ff6961"} />
      );
    }
    
    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.pollCreation) {
      return <PollPreviewQuotedMessage message={message} />
    }

    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.event) {
      return <EventPreviewQuotedMessage message={message} />;
    }

    else if (message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.pix) {
      return <PixMessage message={message} isQuoted={true} />
    }
    
    else {

      const handleClick = (event) => {
        event.preventDefault();
        saveFile(message);
      }

      return (
        <>
          <div className={classes.downloadMedia}>
            <Button
              startIcon={<GetApp />}
              color="inherit"
              variant="outlined"
              target="_blank"
              href="#"
              onClick={handleClick}
            >
              {i18n.t("messagesInput.download")}
            </Button>
            
          </div>
          <Divider />
        </>
      );
    }
  };

  const validateCheckMessageMedia = (message) => {
    const shouldCheckMessageMedia = message.mediaUrl
      || [
        DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.vcard
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.multiVcard
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.location
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.pollCreation
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.event
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.pix
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.viewOnce
      ].includes(message.mediaType);

    if (shouldCheckMessageMedia) return checkMessageMedia(message);
    else return <></>;
  }

  const handleOpenShareContactModal = () => { setShareContactModalOpen(true); };

  const handleCloseShareContactModal = () => {
    setShareContactModalOpen(false);
    setReplyingMessage(null);
  };

  const handleOpenStickersModalOpen = () => { setStickersModalOpen(true); };
  const handleCloseStickersModalOpen = () => { setStickersModalOpen(false); };

  const handleOpenForwardMessageContactModal = () => { setForwardMessageContactModalOpen(true); };
  const handleCloseForwardMessageContactModal = () => { setForwardMessageContactModalOpen(false); };

  const handleChangeInput = (event) => {
    if (inputMessage === "" && event.target.value === "\n") return;
    if (ticketStatus === "group" && groupMessageLock && event.nativeEvent.inputType === "insertLineBreak") return;

    const newValue = event.target.value.length >= DefaultValuesUtils.TEXT_SIZES.inputTextArea
      ? event.target.value.substring(0, DefaultValuesUtils.TEXT_SIZES.inputTextArea - 1)
      : event.target.value;

    setInputMessage(newValue);
    handleLoadQuickAnswer(newValue);
    handleLoadGroupMembers(newValue);
    setInputTextBlurInteraction(false);
  };

  const handleQuickAnswersClick = (value) => {
    setInputMessage(value);
    setTypeBar(false);
  };

  const handleGroupMembersClick = (memberNumber) => {
    setMentionsArray((previousValue) => {
      return groupTicketId === ticketId
        ? [...previousValue, { memberNumber: memberNumber }]
        : [{ memberNumber: memberNumber }];
    });
    
    setInputMessage((previousValue) => {
      const lastAtIndex = previousValue.lastIndexOf("@");
      const beforeMentionText = previousValue.substring(0, lastAtIndex + 1);
      return `${beforeMentionText}${memberNumber} `;
    });

    setTypeAt(false);
  };

  const handleAddEmoji = (event) => {
    let emoji = event.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const handleChangeMedias = (event) => {
    if (!event.target.files) { return; }

    const uploadedFiles = [];
    for (let index = 0; index < event.target.files.length && index < 5; index++) {
      uploadedFiles.push(event.target.files[index]);
    }

    handleOpenFileContextModal(uploadedFiles);
  };

  const handleImageToSticker = (event) => {
    if (!event.target.files) { return; }
    
    const file = event.target.files[0];
    const fileType = file.type.split("/")[0];

    if (fileType === "image") { handleOpenImageToStickerContextModal(file); }
    else {
      toast.info(i18n.t("messagesInput.toasts.onlyImageAllowed"));
      document.getElementById("upload-image-to-sticker").value = "";
    }
  };

  const handleInputPaste = (event) => {
    if (event.clipboardData.files[0]) { 

      const uploadedFiles = [];
      for (let index = 0; index < event.clipboardData.files.length && index < 5; index++) {
        uploadedFiles.push(event.clipboardData.files[index]);
      }

      handleOpenFileContextModal(uploadedFiles);
    }
  };

  const handleSendMessage = async () => {
    if (inputMessage.trim() === "") return;
    if (ticketStatus === "group" && groupMessageLock) return;
    
    setLoading(true);
    
    if (ticketStatus === "group") setGroupMessageLock(true);
    if (ticketType === 2) setBotAnswerDelay(true);

    const shouldSendSignature = ticket.whatsapp
      ? checkForShouldSendSignature(signMessageSetting, ticket.type, ticket.whatsapp)
      : signMessageSetting === "enabled"
    
    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: shouldSendSignature ? `*${user?.name}:*\n${inputMessage.trim()}` : inputMessage.trim(),
      quotedMsg: replyingMessage,
      groupMembersMention: mentionsArray,
      isInternalMessage
    };

    setInputMessage("");
    setMentionsArray([]);

    try {
      await api.post(`/messages/${ticketId}`, message);
    }
    catch (exception) {
      console.log("Handle Send Message Exception:", exception);
      toastError(exception);
    }

    setShowEmoji(false);
    setLoading(false);
    if (ticketStatus === "group") setTimeout(() => setGroupMessageLock(false), 1000);
    setReplyingMessage(null);
    setIsInternalMessage(false);

    if (ticketType === 2) setBotAnswerDelay(false);
  };

  const handleStartRecording = async () => {
    setLoading(true);
    
    navigator.permissions.query({ name: "microphone" }).then(async (permissionStatus) => {
      // ***---- Permission: Granted or Requested ----***
      if (permissionStatus.state === "granted" || permissionStatus.state === "prompt") {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          const audioTracks = stream.getAudioTracks();
          const track = audioTracks[0];

          // ***---- No Mic Detected ----***
          if (audioTracks.length === 0) {
            toast.info(i18n.t("messagesInput.micAudioConditions.micNotDetected"));
            setLoading(false);
            return;
          }

          // ***----- Mic is Muted by Device ----***
          if (track.muted) {
            toast.info(i18n.t("messagesInput.micAudioConditions.permissionDeniedBySystem"));
            setLoading(false);
            return;
          }

          // ***---- Mic is Disabled by User ----***
          if (!track.enabled) {
            toast.info(i18n.t("messagesInput.micAudioConditions.micNotEnabled"));
            setLoading(false);
            return;
          }

          // ***---- Lost Connection with Mic ----***
          if (track.readyState === "ended") {
            toast.info(i18n.t("messagesInput.micAudioConditions.lostConnection"));
            setLoading(false);
            return;
          }

          await Mp3Recorder.start();
          setRecording(true);
          setLoading(false);
        }
        catch (exception) {
          if (exception.message === "Permission denied by system") {
            toast.info(i18n.t("messagesInput.micAudioConditions.permissionDeniedBySystem"));
          }
          else if (exception.message === "Requested device not found") {
            toast.info(i18n.t("messagesInput.micAudioConditions.requestedDeviceNotFound"));
          }
          else {
            console.log("Handle Start Recording Exception:", exception);
            toastError(exception);
          }

          setLoading(false);
        }
      }
      
      // ***---- Permission: Denied ----***
      else if (permissionStatus.state === "denied") {
        toast.info(i18n.t("messagesInput.toasts.audioAccessNotAllowed"));
      }
    });

    setLoading(false);
  };

  const handleFinishAudio = async (shouldUploadAudio) => {
    const resetStates = () => {
      setRecording(false);
      setReplyingMessage(null);
      setIsInternalMessage(false);
      setLoading(false);
      setIsSendingAudio(false);
    };

    //  ******************
    //  ** Cancel Audio **
    //  ******************
    if (!shouldUploadAudio) {
      try {
        await Mp3Recorder.stop();
      } catch (exception) {
        console.log("Handle Cancel Audio Exception:", exception);
      } finally {
        resetStates();
        return;
      }
    }

    //  ******************
    //  ** Upload Audio **
    //  ******************
    setLoading(true);
    setIsSendingAudio(true);

    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();

      if (blob.size < 10000) {
        toast.info(i18n.t("messagesInput.toasts.smallAudio"));
      }
      else {
        const filename = `${new Date().getTime()}.mp3`;
        
        const formData = new FormData();
        if (replyingMessage) formData.append("quotedMsgId", replyingMessage.id);
        formData.append("medias", blob, filename);
        formData.append("fromMe", true);
        formData.append("isInternalMessage", isInternalMessage);
        
        try {
          const { data } = await api.post(`/messages/${ticketId}`, formData);
          if (data.invalidMedias?.length > 0) handleOpenMedialNotSupportedModal(data.invalidMedias);
        }
        catch (exception) {
          console.log("Handle Upload Audio to Backend Exception:", exception);
          toastError(exception);    
        }
      }
    } catch (exception) {
      console.log("Handle Upload Audio Exception:", exception);
    } finally {
      resetStates();
    }
  };

  const handleLoadGroupMembers = async (value) => {
    // ***---- There are no typed text ----***
    if (value === null || value === undefined) {
      setTypeAt(false);
      return;
    }

    // ***---- There are no typed "@" ----***
    const atIndex = value.lastIndexOf("@");

    if (atIndex === -1) {
      setTypeAt(false);
      return;
    }

    // ***---- Fetching group members ----***
    const isAtLastCharacter = atIndex === value.length - 1;
    const isFiltering = !["", " "].includes(value[atIndex + 1]);

    if (ticketStatus === "group" && isAtLastCharacter && isFiltering) {
      try {
        if (groupMembers.length > 0 && groupTicketId === ticketId) {
          setTypeAt(true);
          return;
        }

        setMentionsArray([]);
        setGroupMembers([]);

        const apiCalls = [api.get(`/groupParticipants/${ticketId}`), api.get(`/whatsappInfo/${whatsappId}`)];
        const [GroupParticipantsResponse, WhatsappInfoResponse] = await Promise.all(apiCalls);
        const whatsappJid = JidUtils.unformatJid(WhatsappInfoResponse.data.id);
        
        const groupMembersArray = GroupParticipantsResponse.data.filter(member => member.number !== whatsappJid);
        groupMembersArray.sort((memberA, memberB) => {
          if (memberA.id === DefaultValuesUtils.JIDS.allGroupMembers) return -1;
          if (memberB.id === DefaultValuesUtils.JIDS.allGroupMembers) return 1;
          return memberA.name.localeCompare(memberB.name);
        });

        setGroupMembers(groupMembersArray);
        setTypeAt(groupMembersArray.length > 0);
        setGroupTicketId(ticketId);
      }
      catch (exception) {
        setTypeAt(false);
      }
    }

    // ***---- Ticket is not group or typed "@" is not last character ----***
    else {
      setTypeAt(false);
    }
  };

  const handleLoadQuickAnswer = async (value) => {
    if (value === null || value === undefined) {
      setTypeBar(false);
      return;
    }

    const slashIndex = value.indexOf("/");

    if (slashIndex === -1 ) {
      setTypeBar(false);
      return;
    }

    // ***---- Fetching Quick Answers ----***
    const isFirstCharacter = slashIndex === 0;
    const isFiltering = !["", " "].includes(value[slashIndex + 1]);

    const shouldOpenQuickAnswers = isFirstCharacter && isFiltering && allQuickAnswers.length > 0;
    setTypeBar(shouldOpenQuickAnswers);
  };

  const handleOpenMenuClick = (event) => { setAnchorEl(event.currentTarget); };

  const handleMenuItemClick = (event) => { setAnchorEl(null); };

  const handleCancelForwarding = () => {
    updateIsForwarding(false);
    updateSelectedForwardMessages([]);
  };

  const handleConfirmForwarding = () => {
    if (selectedForwardMessages.length === 0) {
      toast.info(i18n.t("messagesList.toast.forwardMessage.noSelectedMessages"));
    } else {
      handleOpenForwardMessageContactModal();
    }
  };

  const renderReplyingMessage = (message) => {
    return (
      <div className={classes.replyingMsgWrapper}>
        <div className={classes.replyingMsgContainer}>
          <span
            className={clsx(classes.replyingContactMsgSideColor, {
              [classes.replyingSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyingMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.contact?.name}
              </span>
            )}

            {![
              DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.vcard
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.multiVcard
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.image
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.sticker
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.audio
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.video
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.location
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.application
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.ptv
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.pollCreation
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.event
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.pix
              , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.template
            ].includes(message.mediaType) && message.body}

            {message.mediaType === DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.template && (
              TemplateMessageUtils.renderTemplate(message, null, false)
            )}

            {message.mediaType !== DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.template && (
              validateCheckMessageMedia(message)
            )}
          </div>
        </div>
        <IconButton
          component="span"
          disabled={((ticketReadOnly) || (ticketStatus !== "open" && ticketStatus !== "group" && user.profile === "user"))}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  const handleIsSendingSticker = () => {
    setIsSendingSticker(prevStatus => !prevStatus);
  };

  const handleKeyDown = async (event) => {
    if (event.shiftKey) {
      return;
    }
    else if (event.key === "Enter" && !typeBar && !typeAt && (!isSmallScreen || (isSmallScreen && enterIsSendMobileSetting === "enabled"))) {
      await handleSendMessage();
    }
    else if (lastMessage && lastMessage.fromMe) {
      if (event.key !== "ArrowUp") return;
      if (inputMessage !== "") return;
      if ([0, 9].includes(lastMessage.ack)) return;

      const canMessageTypeBeEdited = [
        DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.application
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.chat
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.image
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.transferenceObservation
        , DefaultValuesUtils.MESSAGE_TYPES.convertedTypes.video
      ].includes(lastMessage.mediaType);
      
      if (!canMessageTypeBeEdited) return;

      const userIdOrAdmin = lastMessage.userId === user.id || user.profile === "admin";
      if (!userIdOrAdmin) return;

      const notTicketPendingAndUserNotAdmin = ticketStatus !== "pending" || user.profile !== "user";

      const ticketWhatsappCondition = ticketType === 0
        && lastMessage.fromMe
        && !lastMessage.isViewOnce
        && lastMessage.body
        && ![0, 1].includes(lastMessage.ack)
        && notTicketPendingAndUserNotAdmin;

      const shouldValidateMessageEdition = ticketWhatsappCondition || [1, 3, 4].includes(ticketType);

      if (shouldValidateMessageEdition) {
        try {
          await api.put(`/messagesValidateEdit/${lastMessage.id}`, { whatsappId: ticket.whatsappId, isMessageInternal: lastMessage.isInternal, ticketType });
          handleOpenMessageEditModal();
        }
        catch (exception) {
          console.log("Exception caught while arrow upping to edit messages:", exception);
          toastError(exception);
        }
      }
    }
  }

  //  ---- Handlers ----
  const renderTextAreaPlaceholder = () => {
    const isInputEnabled = (["open", "group"].includes(ticketStatus) || user.profile === "admin") && !ticketReadOnly;
    const isInputEnabledDesktop = isInputEnabled && !isSmallScreen;
    const isInputEnabledMobile = isInputEnabled && isSmallScreen;
    const isTicketReadOnly = ticketStatus === "group" && ticketReadOnly;

    if (isInputEnabledDesktop) return "messagesInput.placeholderOpen";
    if (isInputEnabledMobile) return "messagesInput.placeholderOpenMobile";
    if (isTicketReadOnly) return "messagesInput.placeholderReadOnlyGroup";
    return "messagesInput.placeholderClosed";
  };

  const renderMessageInputContactBlockedOrInactive = () => {
    return (
      <Paper square elevation={0} className={classes.mainWrapper}>
        <div className={classes.newMessageBox}>
          <div className={classes.messageInputWrapper}>
            <Typography variant="subtitle1" className={`${classes.messageInput} ${classes.disabledMessageInput}`}>
              {isContactBlocked && i18n.t("messagesInput.placeholderBlockedContact")}
              {isContactInactive && i18n.t("messagesInput.placeholderInactiveContact")}
						</Typography>
          </div>
        </div>
      </Paper>
    );
  };

  const renderMessageInputOfficialApiTicketStatusGroup = () => {
    return (
      <Paper square elevation={0} className={classes.mainWrapper}>
        <div className={classes.newMessageBox}>
          <div className={classes.messageInputWrapper}>
            <Typography variant="subtitle1" className={`${classes.messageInput} ${classes.disabledMessageInput}`}>
              {i18n.t("messagesInput.placeholderGroupForOfficialApi")}
						</Typography>
          </div>
        </div>
      </Paper>
    );
  };

  const renderMessageInputOfficialApiChatWindowClosed = () => {
    return (
      <React.Fragment>
        <TemplateSendingModal
          open={templateSendingModalOpen}
          onClose={handleCloseTemplateSendingModal}
          ticketId={ticket.id}
          contactId={ticket.contactId}
          whatsappId={ticket.whatsappId}
        />

        <Paper square elevation={0} className={classes.mainWrapper}>
          <div className={classes.newMessageBox}>
            <div className={`${classes.messageInputWrapper} ${classes.messageInputWrapperColumn}`}>
              <Typography variant="subtitle1" className={`${classes.messageInput} ${classes.disabledMessageInput}`}>
                {i18n.t('messageException.modalMessage.chat_window_closed')}
              </Typography>

              <Button
                color='inherit'
                variant='outlined'
                className={classes.floatingButton}
                onClick={handleOpenTemplateSendingModal}
              >
                {i18n.t('templates.title')}
              </Button>
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  };

  const renderMessageInputSendingGifOrSticker = () => {
    return (
      <Paper ref={inputContainer} elevation={0} square className={classes.viewMediaInputWrapper}>
        {(loading || isSendingGif || isSendingSticker) && (
          <div>
            <CircularProgress className={classes.circleLoading} variant="determinate" value={progress} />
          </div>
        )}

        <IconButton
          component="span"
          disabled={ticketReadOnly || loading || isSendingGif || isSendingSticker || (ticketStatus !== "open" && ticketStatus !== "group" && user.profile === "user")}
        >
          {(isSendingGif || isSendingSticker) && <HourglassEmptyIcon className={classes.sendMessageIcons} />}
        </IconButton>
      </Paper>
    );
  };

  const renderMessageInputRecordingAudio = () => {
    return (
      <Paper elevation={0} square className={classes.mainWrapper}>
        <div className={classes.recorderWrapper}>
          <IconButton
            component="span"
            fontSize="large"
            onClick={async () => await handleFinishAudio(false)}
          >
            <HighlightOffIcon className={classes.cancelAudioIcon} />
          </IconButton>

          {loading ? (<div><CircularProgress className={classes.audioLoading} /></div>) : (<RecordingTimer />)}

          <IconButton
            component="span"
            fontSize="large"
            disabled={isSendingAudio}
            onClick={async () => await handleFinishAudio(true)}
          >
            <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
          </IconButton>

          {ticketType === 0 && (
            <InternalMessageIconContainer
              isInternalMessage={isInternalMessage}
              setIsInternalMessage={setIsInternalMessage}
              userProfile={user.profile}
              ticketReadOnly={ticketReadOnly}
              ticketStatus={ticketStatus}
            />
          )}
        </div>
      </Paper>
    );
  };

  const renderMessageInputDefault = () => {
    return (
      <Paper elevation={0} square className={classes.mainWrapper}>
        <MediaNotSupportedModal
          open={isMediaNoSupportedModalOpen}
          onClose={handleCloseMedialNotSupportedModal}
          medias={mediasNotSupported}
        />

        {lastMessageModal && (
          <MessageEditModal
            open={messageEditModalOpen}
            onClose={handleCloseMessageEditModal}
            message={lastMessageModal}
          />
        )}

        {ticketType === 0 && !ticket.whatsapp?.isMetaApi && (
          <PollModal
            open={pollModalOpen}
            onClose={handleClosePollModal}
            ticketId={ticketId}
          />
        )}

        <LocationModal
          open={locationModalOpen}
          onClose={handleCloseLocationModal}
          ticketId={ticketId}
        />

        <CameraModal
          open={cameraModalOpen}
          onClose={handleCloseCameraModal}
          ticketId={ticketId}
        />

        <StickersModal
          open={stickersModalOpen}
          onClose={handleCloseStickersModalOpen}
          ticketId={ticketId}
          handleIsSendingSticker={handleIsSendingSticker}
        />

        <ShareContactsModal
          open={shareContactModalOpen}
          onClose={handleCloseShareContactModal}
          ticket={ticketId}
          ticketType={ticketType}
        />

        <PixModal
          open={pixModalOpen}
          onClose={handleClosePixModal}
          ticketId={ticketId}
        />

        {replyingMessage && (
          <ShareContactsModal
            open={shareContactModalOpen}
            onClose={handleCloseShareContactModal}
            ticket={ticketId}
            replyingMessageId={replyingMessage.id}
            ticketType={ticketType}
          />
        )}

        {!ticket.whatsapp?.isMetaApi && (
          <ForwardMessageContactModal
            ticketId={ticketId}
            open={forwardMessageContactModalOpen}
            onClose={handleCloseForwardMessageContactModal}
            selectedForwardMessages={selectedForwardMessages}
            updateIsForwarding={updateIsForwarding}
            updateSelectedForwardMessages={updateSelectedForwardMessages}
          />
        )}

        {replyingMessage && renderReplyingMessage(replyingMessage)}

        <div className={classes.newMessageBox}>
          {/* 
            *********************
            ** Emojis and Gifs **
            *********************
          */}       
          <Tooltip title={i18n.t("messagesInput.tooltips.emojis")} placement="top-start" arrow>
            <IconButton
              component="span"
              disabled={shouldDisableButton}
              onClick={(event) => setShowEmoji((prevState) => !prevState)}
            >
              <MoodIcon className={classes.sendMessageIcons} />
            </IconButton>
          </Tooltip>

          {showEmoji ? (
            <ClickAwayListener onClickAway={() => setShowEmoji(false)}>
              <div className={classes.emojiBox}>
                <Picker
                  data={data}
                  onEmojiSelect={handleAddEmoji}
                  emojiButtonSize={30}
                  emojiSize={25}
                  icons={"outline"}
                  locale={localStorage.getItem("i18nextLng").substring(0, 2)}
                  navPosition={"bottom"}
                  perLine={12}
                  showPreview={true}
                  previewEmoji={"point_up"}
                  previewPosition={"bottom"}
                  set={"native"}
                  emojiVersion={15}
                  showSkinTones={true}
                  skinTonePosition={"search"}
                  theme={localStorage.getItem("theme")}
                />
              </div>
            </ClickAwayListener>
          ) : null}
          
          {/* 
            ****************
            ** Input Area **
            ****************
          */}
          <div className={classes.messageInputWrapper}>
            <InputBase
              id="textArea"
              spellCheck="true"
              inputRef={(input) => {
                const shouldBlurInput = isSmallScreen && inputTextBlurInteraction;
                
                if (shouldBlurInput) {
                  inputRef.current.blur();
                  return;
                }

                const shouldFocusInput = input
                  && !fileContextModalOpen
                  && !imageToStickerContextModalOpen
                  && !isContactModalOpen
                  && !showEmoji
                  && !messageEditModalOpen
                  && !pollModalOpen
                  && !locationModalOpen
                  && !pixModalOpen
                  && !cameraModalOpen
                  && !stickersModalOpen
                  && !shareContactModalOpen
                  && !forwardMessageContactModalOpen;

                if (shouldFocusInput) input.focus();
                if (input) inputRef.current = input;
              }}
              className={classes.messageInput}
              placeholder={i18n.t(renderTextAreaPlaceholder())}
              multiline
              maxRows={5}
              value={inputMessage}
              onChange={handleChangeInput}
              disabled={shouldDisableButton}
              onPaste={(event) => {
                ticketStatus === "open" && ticketType !== 2 && handleInputPaste(event);
                ticketStatus === "pending" && ticketType !== 2 && user.profile === "admin" && handleInputPaste(event);
                ticketStatus === "group" && ticketType !== 2 && handleInputPaste(event);
              }}
              onKeyDown={async (event) => await handleKeyDown(event)}
            />

            <QuickAnswersList
              quickAnswers={allQuickAnswers}
              handleQuickAnswersClick={handleQuickAnswersClick}
              typeBar={typeBar}
              setTypeBar={setTypeBar}
              filter={inputMessage}
            />

            <GroupMembersMentionList
              groupMembers={groupMembers}
              handleGroupMembersClick={handleGroupMembersClick}
              typeAt={typeAt}
              setTypeAt={setTypeAt}
              filter={inputMessage}
            />
          </div>


        
          {/* 
            ************************
            ** Forwarding Message **
            ************************        
          */}
          {isForwarding && (
            <>

            {/* 
              ************
              ** Cancel **
              ************
            */}
            <Tooltip title={i18n.t("messagesInput.tooltips.cancel")} placement="top-start" arrow>
              <IconButton onClick={handleCancelForwarding}>
                <CancelOutlinedIcon className={classes.sendMessageIcons} />
              </IconButton>
            </Tooltip>



            {/* 
              *************
              ** Confirm **
              *************
            */}
            <Tooltip title={i18n.t("messagesInput.tooltips.confirm")} placement="top-start" arrow>
              <IconButton onClick={handleConfirmForwarding}>
                <CheckCircleOutlineOutlinedIcon className={classes.sendMessageIcons} />
              </IconButton>
            </Tooltip>
            </>
          )}

        

          {/* 
            ****************************
            ** Not Forwarding Message **
            ****************************
            
            - just when ticket is not a bot chat
          */}
          {!isForwarding && ticketType !== 2 && (
            <>
              {ticketType === 0 && (
                <InternalMessageIconContainer
                  isInternalMessage={isInternalMessage}
                  setIsInternalMessage={setIsInternalMessage}
                  userProfile={user.profile}
                  ticketReadOnly={ticketReadOnly}
                  ticketStatus={ticketStatus}
                />
              )}

              <div>
                {/* 
                  ***********************
                  ** Icon to Open Menu **
                  ***********************
                */}
                <Tooltip title={i18n.t("messagesInput.tooltips.moreVert")} placement="top-start" arrow>
                  <IconButton 
                    className={classes.moreVert} 
                    aria-controls="simple-menu" 
                    aria-haspopup="true" 
                    onClick={handleOpenMenuClick}
                    disabled={ticketReadOnly}
                  >
                    <MoreVert></MoreVert>
                  </IconButton>
                </Tooltip>

                {/* 
                  **********
                  ** Menu **
                  **********
                */}
                <Menu
                  id="simple-menu"
                  keepMounted
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuItemClick}
                  MenuListProps={{ className: classes.menuList }}
                >
                  {/*
                    ****************
                    ** Take Photo **
                    ****************
                  */}
                  {!isSmallScreen && (
                    <MenuItem onClick={handleMenuItemClick}>
                      <Tooltip title={i18n.t("messagesInput.tooltips.takePhoto")} placement="top-start" arrow>
                        <IconButton
                          component="span"
                          disabled={shouldDisableButton}
                          onClick={handleDeviceHasCameras}
                        >
                          <CameraAltOutlinedIcon className={`${classes.sendMessageIcons} ${classes.takePhotoIcon}`} />
                        </IconButton>
                      </Tooltip>
                    </MenuItem>
                  )}

                  {/* 
                    **************
                    ** Stickers **
                    **************
                  */}
                  {(ticketType === 0 || ticketType === 3) && (
                    <MenuItem onClick={handleMenuItemClick}>
                      <Tooltip title={i18n.t("messagesInput.tooltips.stickers")} placement="top-start" arrow>
                        <IconButton
                          component="span"
                          disabled={shouldDisableButton}
                          onClick={handleOpenStickersModalOpen}
                        >
                          <InsertDriveFileOutlinedIcon className={`${classes.sendMessageIcons} ${classes.stickersIcon}`} />
                        </IconButton>
                      </Tooltip>
                    </MenuItem>
                  )}

                  {/* 
                    ********************
                    ** Create Sticker **
                    ********************
                  */}
                  {(ticketType === 0 || ticketType === 3) && (
                    <MenuItem onClick={handleMenuItemClick}>
                      <input
                        type="file"
                        id="upload-image-to-sticker"
                        disabled={shouldDisableButton}
                        className={classes.uploadInput}
                        onChange={handleImageToSticker}
                        accept="image/*"
                      />

                      <Tooltip title={i18n.t("messagesInput.tooltips.createStickers")} placement="top-start" arrow>
                        <label htmlFor="upload-image-to-sticker">
                          <IconButton
                            component="span"
                            disabled={shouldDisableButton}
                          >
                            <WallpaperOutlinedIcon className={`${classes.sendMessageIcons} ${classes.createStickersIcon}`} />
                          </IconButton>
                        </label>
                      </Tooltip>
                    </MenuItem>
                  )}

                  {/* 
                    *******************
                    ** Contact VCard **
                    *******************
                  */}
                  <MenuItem onClick={handleMenuItemClick}>
                    <Tooltip title={i18n.t("messagesInput.tooltips.vcard")} placement="top-start" arrow>
                      <IconButton
                        component="span"
                        disabled={shouldDisableButton}
                        onClick={handleOpenShareContactModal}
                      >
                        <PersonOutlineOutlinedIcon className={`${classes.sendMessageIcons} ${classes.contactsIcon}`} />
                      </IconButton>
                    </Tooltip>
                  </MenuItem>

                  {/* 
                    **********
                    ** Poll **
                    **********
                  */}
                  {ticketType === 0 && !ticket.whatsapp?.isMetaApi && (
                    <MenuItem onClick={handleMenuItemClick}>
                      <Tooltip title={i18n.t("messagesInput.tooltips.poll")} placement="top-start" arrow>
                        <IconButton
                          component="span"
                          disabled={shouldDisableButton}
                          onClick={handleOpenPollModal}
                        >
                          <PollOutlinedIcon className={`${classes.sendMessageIcons} ${classes.pollIcon}`} />
                        </IconButton>
                      </Tooltip>
                    </MenuItem>
                  )}

                  {/* 
                    **************
                    ** Location **
                    **************
                  */}
                  {ticketType === 0 && (
                    <MenuItem onClick={handleMenuItemClick}>
                      <Tooltip title={i18n.t("messagesInput.tooltips.location")} placement="top-start" arrow>
                        <IconButton
                          component="span"
                          disabled={shouldDisableButton}
                          onClick={handleOpenLocationModal}
                        >
                          <LocationOnOutlined className={`${classes.sendMessageIcons} ${classes.locationIcon}`} />
                        </IconButton>
                      </Tooltip>
                    </MenuItem>
                  )}
                  

                  {/* 
                    *****************
                    ** Attach File **
                    *****************
                  */}
                  <MenuItem onClick={handleMenuItemClick}>
                    <input
                      type="file"
                      multiple
                      id="upload-button"
                      disabled={shouldDisableButton}
                      className={classes.uploadInput}
                      onChange={handleChangeMedias}
                    />
                    <Tooltip title={i18n.t("messagesInput.tooltips.attach")} placement="top-start" arrow>
                      <label htmlFor="upload-button">
                        <IconButton
                          component="span"
                          disabled={shouldDisableButton}
                        >
                          <AttachFileIcon className={`${classes.sendMessageIcons} ${classes.attachFileIcon}`} />
                        </IconButton>
                      </label>
                    </Tooltip>
                  </MenuItem>



                  {/* 
                    *********
                    ** Pix **
                    *********
                  */}
                  {ticketType === 0 && (
                    <MenuItem onClick={handleMenuItemClick}>
                      <Tooltip title={i18n.t("messagesInput.tooltips.pix")} placement="top-start" arrow>
                        <IconButton
                          component="span"
                          disabled={shouldDisableButton}
                          onClick={handleOpenPixModal}
                        >
                          <MonetizationOnOutlinedIcon className={`${classes.sendMessageIcons} ${classes.pixIcon}`} />
                        </IconButton>
                      </Tooltip>
                    </MenuItem>
                  )}
                </Menu>
              </div>

              {/* 
                ******************
                ** Record Audio **
                ******************
              */}
              {inputMessage ? (
                <Tooltip title={i18n.t("messagesInput.tooltips.send")} placement="top-start" arrow>
                  <IconButton
                    component="span"
                    onClick={handleSendMessage}
                    disabled={((ticketReadOnly) || (!["open", "group"].includes(ticketStatus) && user.profile === "user"))}
                  >
                    <SendIcon disabled={((ticketReadOnly) || (!["open", "group"].includes(ticketStatus) && user.profile === "user"))} className={classes.sendMessageIcons} />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={i18n.t("messagesInput.tooltips.record")} placement="top-start" arrow>
                  <IconButton
                    component="span"
                    disabled={shouldDisableButton}
                    onClick={async () => await handleStartRecording()}
                  >
                    <MicIcon className={classes.sendMessageIcons} />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}



          {/* 
            ****************************
            ** Not Forwarding Message **
            ****************************
            
            // ticket is a bot chat: only send icon is available
          */}
          {ticketType === 2 && (
            <Tooltip title={i18n.t("messagesInput.tooltips.send")} placement="top-start" arrow>
              <IconButton
                component="span"
                onClick={handleSendMessage}
                disabled={((ticketReadOnly) || (ticketStatus !== "open" && ticketStatus !== "group" && user.profile === "user"))}
              >
                <SendIcon disabled={((ticketReadOnly) || (ticketStatus !== "open" && ticketStatus !== "group" && user.profile === "user"))} className={classes.sendMessageIcons} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </Paper>
    );
  };



  //  ************
  //  ** Return **
  //  ************
  if (isContactBlocked || isContactInactive) return renderMessageInputContactBlockedOrInactive();
  if (ticketStatus === 'group' && ticket.whatsapp?.isMetaApi) return renderMessageInputOfficialApiTicketStatusGroup();
  if (ticket.whatsapp?.isMetaApi && ticket.isChatWindowClosed) return renderMessageInputOfficialApiChatWindowClosed();
  if (isSendingGif || isSendingSticker) return renderMessageInputSendingGifOrSticker();
  if (recording) return renderMessageInputRecordingAudio();
  return renderMessageInputDefault();
};

export default MessageInput;
